<template>
  <div class="profile-page">
    <header class="profile-header">
      <button
        type="button"
        class="profile-back"
        :aria-label="$t('profileDetail.back')"
        @click="goBack"
      >
        <img
          src="../images/ban6/left.png"
          alt=""
        >
      </button>
      <h1>{{ $t('profileDetail.title') }}</h1>
    </header>

    <div
      v-if="loading"
      class="profile-state"
    >
      {{ $t('pro2.loading') }}
    </div>
    <div
      v-else-if="loadError"
      class="profile-state"
      role="alert"
    >
      <p>{{ $t('profileDetail.loadFailed') }}</p>
      <button
        type="button"
        class="gold-button"
        @click="start"
      >
        {{ $t('profileDetail.retry') }}
      </button>
    </div>
    <main v-else-if="data">
      <section
        v-if="videoUrl"
        class="profile-video"
      >
        <video
          v-if="!videoFailed"
          :key="videoAttempt"
          ref="profileVideo"
          :src="videoUrl"
          :poster="coverUrl"
          :style="videoStyle"
          controls
          playsinline
          webkit-playsinline
          preload="metadata"
          @loadedmetadata="onVideoMetadata"
          @error="onVideoError"
        />
        <div
          v-else
          class="profile-state"
          role="alert"
        >
          <p>{{ $t('profileDetail.videoFailed') }}</p>
          <button
            type="button"
            class="gold-button"
            @click="retryVideo"
          >
            {{ $t('profileDetail.retry') }}
          </button>
        </div>
      </section>

      <div class="profile-notice">
        <img
          src="../images/ban6/ico_notice.png"
          alt=""
        >
        <div class="profile-notice-text">
          <marquee scrollamount="3">
            {{ noticeText }}
          </marquee>
        </div>
        <span class="notice-link">
          {{ $t('profileDetail.notice') }}
        </span>
      </div>
      <p class="profile-id">
        {{ $t('profileDetail.id') }}: {{ displayId }}
      </p>

      <section class="profile-panel score-panel">
        <div class="score-value">
          <span>{{ $t('profileDetail.score') }}</span>
          <strong>{{ scoreText }}</strong>
          <span>{{ $t('profileDetail.beauty') }}</span>
        </div>
        <div class="contact-details">
          <span>
            {{ $t('profileDetail.specificAddress') }}: {{ $t('profileDetail.hiddenContact') }}
          </span>
          <span>
            {{ $t('profileDetail.contact') }}: {{ $t('profileDetail.hiddenContact') }}
          </span>
        </div>
      </section>

      <section class="profile-panel basic-details">
        <p v-if="data.name">
          <img
            src="../images/ban6/ico_res02.png"
            alt=""
          ><span>{{ $t('profileDetail.stageName') }}: {{ data.name }}</span>
        </p>
        <p v-if="data.addr">
          <img
            src="../images/ban6/icon_location.png"
            alt=""
          ><span>{{ $t('profileDetail.location') }}: {{ data.addr }}</span>
        </p>
        <p v-if="introduction">
          <img
            src="../images/ban6/ico_res04.png"
            alt=""
          ><span>{{ $t('profileDetail.introduction') }}: {{ introduction }}</span>
        </p>
      </section>

      <section
        v-if="profileImages.length"
        class="profile-gallery"
      >
        <img
          v-for="(img, index) in profileImages"
          :key="img + index"
          :src="img"
          :alt="data.name"
          loading="lazy"
        >
      </section>
    </main>
  </div>
</template>

<script>
import Fetch from "../../utils/fetch";
import { formatAssetUrl } from "../../utils/assets";

export default {
  name: "Vprofile",
  data() {
    return {
      data: null,
      loading: false,
      loadError: false,
      videoFailed: false,
      videoAttempt: 0,
      videoRatio: null,
      requestVersion: 0,
    };
  },
  computed: {
    displayId() {
      return this.data ? this.data.source_display_id || this.data.id : "";
    },
    videoStyle() {
      return this.videoRatio ? { aspectRatio: String(this.videoRatio) } : {};
    },
    coverUrl() {
      return formatAssetUrl(this.data && this.data.pic);
    },
    videoUrl() {
      return formatAssetUrl(this.data && this.data.video_url);
    },
    scoreText() {
      if (!this.data || this.data.score === null || this.data.score === undefined || this.data.score === "") return "—";
      var score = Number(this.data.score);
      return Number.isFinite(score) && score >= 0 && score <= 10 ? score.toFixed(1) : "—";
    },
    profileImages() {
      var images = this.data && typeof this.data.imgs === "string" ? this.data.imgs.split("|").map(value => value.trim()).filter(Boolean) : [];
      return images.length ? images.map(formatAssetUrl) : (this.coverUrl ? [this.coverUrl] : []);
    },
    introduction() {
      if (!this.data) return "";
      var age = this.getAge(this.data.birthday);
      if (age === null && this.data.source_age !== null && this.data.source_age !== undefined) {
        var sourceAge = Number(this.data.source_age);
        if (Number.isInteger(sourceAge) && sourceAge >= 18 && sourceAge <= 120) age = sourceAge;
      }
      var fields = [
        ["age", age],
        ["bust", this.data.xiong],
        ["height", this.data.height],
        ["weight", this.data.weight],
      ];
      return fields.filter(item => item[1] !== null && item[1] !== undefined && String(item[1]).trim() !== "" && String(item[1]) !== "0")
        .map(item => this.$t("profileDetail." + item[0]) + ": " + item[1]).join("  ");
    },
    noticeText() {
      if (!this.data) return "";
      var parts = [this.data.name];
      if (this.data.addr) parts.push(this.$t("profileDetail.location") + ": " + this.data.addr);
      if (this.introduction) parts.push(this.introduction);
      return parts.filter(Boolean).join("  ");
    },
  },
  watch: {
    "$route.params.code"() {
      this.start();
    },
  },
  created() {
    this.$parent.footer("girl", true);
  },
  mounted() {
    this.start();
  },
  beforeDestroy() {
    this.requestVersion++;
    this.stopVideo();
  },
  methods: {
    goBack() {
      this.stopVideo();
      if (window.history.length > 1) this.$router.back();
      else this.$router.replace("/vchoose");
    },
    stopVideo() {
      if (this.$refs.profileVideo) this.$refs.profileVideo.pause();
    },
    onVideoError() {
      this.stopVideo();
      this.videoFailed = true;
    },
    onVideoMetadata(event) {
      var video = event.target;
      if (video.videoWidth && video.videoHeight) this.videoRatio = video.videoWidth / video.videoHeight;
    },
    retryVideo() {
      this.videoAttempt++;
      this.videoFailed = false;
    },
    getAge(value) {
      if (typeof value !== "string" && typeof value !== "number") return null;
      var match = String(value).trim().match(/^(\d{4})(?:[-/](\d{1,2})[-/](\d{1,2}))?$/);
      if (!match) return null;
      var now = new Date();
      var year = Number(match[1]);
      var age = now.getFullYear() - year;
      if (match[2]) {
        var month = Number(match[2]);
        var day = Number(match[3]);
        var birth = new Date(year, month - 1, day);
        if (birth.getFullYear() !== year || birth.getMonth() !== month - 1 || birth.getDate() !== day || birth > now) return null;
        if (now.getMonth() + 1 < month || (now.getMonth() + 1 === month && now.getDate() < day)) age--;
      }
      return age >= 0 && age <= 120 ? age : null;
    },
    start() {
      var version = ++this.requestVersion;
      this.stopVideo();
      this.loading = true;
      this.loadError = false;
      this.videoFailed = false;
      this.data = null;
      this.videoRatio = null;
      Fetch("/index/girl", { id: this.$route.params.code }).then(res => {
        if (version !== this.requestVersion) return;
        var girl = res.data && res.data.girl;
        if (!girl || !girl.id) throw new Error("Missing profile");
        this.data = girl;
      }).catch(() => {
        if (version === this.requestVersion) this.loadError = true;
      }).finally(() => {
        if (version === this.requestVersion) this.loading = false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.profile-page {
  --profile-gold: #f3c99e;
  min-height: 100vh;
  padding-bottom: calc(70px + env(safe-area-inset-bottom));
  background: #201c1d;
  color: #f5f3f1;
  box-sizing: border-box;
}
.profile-header {
  position: sticky;
  top: 0;
  z-index: 10;
  min-height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 40px;
  background: #201c1d;
  color: var(--profile-gold);
  box-sizing: border-box;
}
.profile-header h1 { margin: 0; font-size: 14px; line-height: 22px; text-align: center; overflow-wrap: anywhere; }
.profile-back { position: absolute; left: 8px; top: 0; bottom: 0; width: 30px; padding: 8px; border: 0; background: transparent; }
.profile-back img { display: block; width: 8px; height: 14px; object-fit: contain; }
.profile-video { background: #000; }
.profile-video video { display: block; width: 100%; height: auto; }
.profile-notice { margin: 12px 8px 0; padding: 4px 4px 4px 8px; display: flex; align-items: center; gap: 7px; min-height: 32px; border: 1px solid #75654f; border-radius: 4px; background: linear-gradient(110deg, #232323, #303030); box-sizing: border-box; }
.profile-notice > img { flex-shrink: 0; width: 17px; height: 17px; object-fit: contain; }
.profile-notice-text { flex: 1; min-width: 0; overflow: hidden; color: var(--profile-gold); font-size: 12px; line-height: 18px; }
.profile-notice-text marquee { display: block; }
.notice-link { flex-shrink: 0; max-width: 35%; padding: 2px 8px 2px 12px; border-left: 5px solid #877c71; background: #ebba8c; color: #46392f; font-size: 12px; line-height: 18px; overflow-wrap: anywhere; }
.profile-id { margin: 12px 10px; font-size: 14px; line-height: 20px; }
.profile-panel { margin: 4px 10px 0; border: 1px solid #75654f; border-radius: 4px; background: linear-gradient(110deg, #232323, #303030); box-sizing: border-box; }
.score-panel { display: flex; align-items: center; padding: 17px 12px; gap: 16px; }
.score-value { flex: 0 0 78px; min-width: 0; display: flex; flex-direction: column; align-items: center; gap: 6px; text-align: center; font-size: 12px; line-height: 17px; overflow-wrap: anywhere; }
.score-value strong { color: var(--profile-gold); font-size: 24px; line-height: 30px; }
.contact-details { flex: 1; min-width: 0; font-size: 12px; line-height: 17px; word-break: normal; overflow-wrap: anywhere; }
.contact-details > span { display: block; color: inherit; word-break: normal; }
.contact-details > span + span { margin-top: 2px; }
.basic-details { padding: 12px 16px; }
.basic-details p { margin: 4px 0; display: flex; align-items: flex-start; gap: 6px; font-size: 12px; line-height: 17px; }
.basic-details img { flex: 0 0 12px; width: 12px; height: 14px; object-fit: contain; margin-top: 1px; }
.basic-details span { min-width: 0; overflow-wrap: anywhere; white-space: pre-wrap; }
.profile-gallery { margin: 4px 10px 0; }
.profile-gallery img { display: block; width: 100%; height: auto; }
.profile-state { padding: 30px 16px; text-align: center; font-size: 12px; line-height: 20px; color: var(--profile-gold); }
.profile-state p { margin: 0 0 12px; }
.gold-button { padding: 6px 16px; border: 1px solid #75654f; border-radius: 4px; background: #ebba8c; color: #46392f; font-size: 12px; }
@media screen and (max-width: 374px) {
  .score-panel { padding: 14px 10px; gap: 10px; }
  .score-value { flex-basis: 64px; }
  .basic-details { padding: 10px; }
}
</style>
